import React from 'react'
import './index.css'

const RetractModal = () => {
  return (
    <div data-testid="modal-content">
      <p>
        Por ley, <span className="retract-bold">tienes derecho a devolver un producto si te arrepientes</span> de tu
        compra. Esto <span className="retract-bold">sólo aplica para compras online.</span>
      </p>
      <hr className="retract-hr" />
      <h4>Plazo</h4>
      <p>
        Tienes hasta <span className="retract-bold">10 días para hacer la devolución</span> a partir de la fecha en que
        recibiste o retiraste el pedido.
      </p>
      <hr className="retract-hr" />
      <h4>Condiciones</h4>
      <p>
        Aplica para todos los productos de <span className="retract-bold">todas las categorías excepto para:</span>
      </p>
      <ul className="retract-list">
        <li>
          <p>
            <span className="retract-bold">Productos que por su naturaleza no puedan ser devueltos </span>(aquellos que
            no puedan volver a comercializarse en las condiciones ofrecidas originalmente por haberse instalado o
            utilizado más alla de su inspección).
          </p>
        </li>
        <li>
          <p>
            <span className="retract-bold">Productos que puedan deteriorase o caducar con rapidez </span>(aquellos que
            en un plazo inferior a 10 días puedan sufrir la alteración o afectación de su funcionalidad, efectividad,
            apariencia, calidad o valor).
          </p>
        </li>
        <li>
          <p>
            <span className="retract-bold">
              Productos confeccionados conforme a las especificaciones del consumidor.
            </span>
          </p>
        </li>
        <li>
          <p>
            <span className="retract-bold">Productos de uso personal o higiene sellados</span>
          </p>
        </li>
      </ul>
    </div>
  )
}

export default RetractModal
